import React from "react";

export default function TransactionActionsBar({
  selected = [],
  onSendEmail,
  onSelectAll,
  allSelected,
  onCancelSelected,
}) {
  if (!selected.length) return null;

  return (
    <div className="sticky bottom-20 md:bottom-6 z-40">
      <div className="mx-auto max-w-5xl rounded-2xl border border-black/10 dark:border-white/10 bg-white/95 dark:bg-gray-900/90 backdrop-blur px-3 py-3 shadow-lg">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="text-sm text-gray-700 dark:text-gray-200">
            <strong>{selected.length}</strong> sélectionnée(s)
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              onClick={onSelectAll}
              className="px-3 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-900 text-sm
                         dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white"
            >
              {allSelected ? "Désélectionner tout" : "Sélectionner tout"}
            </button>

            <button
              onClick={onSendEmail}
              className="px-3 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-sm"
            >
              Email
            </button>

            <button
              onClick={onCancelSelected}
              className="px-3 py-2 rounded-md bg-amber-700 hover:bg-amber-800 text-white text-sm"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
